import { render, staticRenderFns } from "./donwloadNota.vue?vue&type=template&id=60dbdb4e&"
import script from "./donwloadNota.vue?vue&type=script&lang=js&"
export * from "./donwloadNota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports